import React from 'react';

import { Box, Card, H2, IconButton, Text } from '@betterment/samba-react';
import { css } from '@betterment/samba-styled-system/css';
import { SambaAutoLink } from '@betterment/shared-components';

import { trackClick } from '../../features/track';
import { ContentCardProps } from '../data';

const SecondaryCard: React.FC<ContentCardProps & { isAccountOverview?: boolean }> = ({
  title,
  description,
  linkText,
  imageUrl,
  dismissible,
  url,
  handleDismissal,
  handleCardClick,
  isAccountOverview = false,
  trackingModule: eventModule,
  trackingFlow: eventFlow,
  extras: { name: eventName, imageAltText, linkTarget },
}) => {
  const layoutDirection = isAccountOverview ? 'column' : 'row';

  return (
    <Card css={{ position: 'relative', px: 'space.0', mb: 'space.200' }}>
      <Box css={{ display: 'flex', flexDirection: ['column', 'row', layoutDirection, layoutDirection, 'column'] }}>
        <Box>
          {imageUrl && (
            <img
              className={css({ objectFit: 'cover', width: '100%', height: '100%' })}
              src={imageUrl}
              alt={imageAltText || title}
            />
          )}
        </Box>
        <Box data-testid="braze-card-body" css={{ display: 'flex', flexDirection: 'column', p: 'space.300' }}>
          <H2 variant="title200">{title}</H2>
          <Text variant="text100" css={{ mb: 'space.0' }} dangerouslySetInnerHTML={{ __html: description }} />
          {url && linkText && (
            <Box css={{ display: 'flex', mt: 'space.200', mr: 'space.150', cursor: 'pointer' }} asChild={true}>
              <SambaAutoLink
                to={url}
                target={linkTarget}
                rel="noopener noreferrer"
                onClick={(event: React.MouseEvent<HTMLAnchorElement>) => {
                  trackClick({ name: `${eventName}_${linkText}`, module: eventModule, flow: eventFlow });
                  handleCardClick(event);
                }}
                data-testid="contentCardLink"
              >
                {linkText}
              </SambaAutoLink>
            </Box>
          )}
        </Box>
      </Box>
      {dismissible && (
        <IconButton
          css={{ position: 'absolute', top: 'space.200', right: 'space.200' }}
          label="Dismiss card"
          onClick={handleDismissal}
          name="X"
          color="icon.weak"
        />
      )}
    </Card>
  );
};

export default SecondaryCard;
